import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateRelatedContact as UpdateRelatedContactMutation,
    UpdateRelatedContactVariables,
    ContactUpdateInput,
} from 'nutshell-graphql-types';

import CONTACT_FOR_CORE_ENTITY_FRAGMENT from '../../../../../../core-entity/graphql/fragments/contact-for-core-entity-fragment.graphql';

import UPDATE_RELATED_CONTACT from '../mutations/update-related-contact.graphql';

export const useUpdateRelatedContact = (): {
    updateRelatedContact: (input: ContactUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateRelatedContact, {loading, error}] = useMutation<
        UpdateRelatedContactMutation,
        UpdateRelatedContactVariables
    >(UPDATE_RELATED_CONTACT);

    return {
        updateRelatedContact: (input: ContactUpdateInput) =>
            updateRelatedContact({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedContact = mutationResults?.data?.contactUpdate?.contact;

                    if (!updatedContact) {
                        return;
                    }

                    proxy.writeFragment({
                        id: updatedContact.id,
                        fragment: CONTACT_FOR_CORE_ENTITY_FRAGMENT,
                        fragmentName: 'ContactForCoreEntityFragment',
                        data: {
                            ...updatedContact,
                        },
                    });
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
